import { useEffect, useState } from 'react'
import { getInvoice } from '../../requests/getInvoice'
import { routes2 } from '@linqpal/models'
import {
  IntegrationErrorCodesType,
  unexpectedErrorCode,
} from '@linqpal/models/src/dictionaries'

export const useGetInvoice = (
  invoiceNumber: string,
  supplierCompanyId: string,
  setErrorCode: (error: IntegrationErrorCodesType | null) => void,
) => {
  const [invoice, setInvoice] = useState<null | any>(null)
  const [invoicePaymentStatus, setInvoicePaymentStatus] = useState<null | any>(
    null,
  )
  const [isInvoicePaid, setIsInvoicePaid] = useState<null | any>(null)
  const [invoiceMetadata, setInvoiceMetadata] = useState<null | any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const bootstrap = async () => {
      setLoading(true)
      const res = await getInvoice({ invoiceNumber, supplierCompanyId })
      if (!res?.invoice?._id) {
        setErrorCode(unexpectedErrorCode)
        setLoading(false)
        return
      }
      const checkInvoicePaid = await routes2.invoice.checkInvoiceIsPaid({
        invoiceId: res.invoice._id,
      })
      setInvoice(res.invoice)
      setInvoiceMetadata(res.invoiceMetadata)
      setInvoicePaymentStatus(checkInvoicePaid?.status)
      setIsInvoicePaid(checkInvoicePaid?.isPaid)
      setLoading(false)
    }
    bootstrap()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber, supplierCompanyId])

  return {
    invoice,
    invoiceMetadata,
    loading,
    isInvoicePaid,
    invoicePaymentStatus,
  }
}

export const useGetInvoiceIdle = (
  invoiceNumber: string,
  supplierCompanyId: string,
) => {
  const [invoice, setInvoice] = useState<null | any>(null)
  const [customer, setCustomer] = useState<null | any>(null)
  const [invoicePaymentStatus, setInvoicePaymentStatus] = useState<null | any>(
    null,
  )
  const [invoiceCreditStatus, setInvoiceCreditStatus] = useState<null | any>(
    null,
  )
  const [isInvoicePaid, setIsInvoicePaid] = useState<null | any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const bootstrap = async () => {
      if (invoiceNumber && supplierCompanyId) {
        setLoading(true)
        const res = await routes2.invoice.showInvoiceIdle({
          invoiceNumber,
          supplierCompanyId,
        })
        if (!res?.invoice?._id) return
        const checkInvoicePaid = await routes2.invoice.checkInvoiceIsPaid({
          invoiceId: res.invoice._id,
        })
        setInvoice(res.invoice)
        setCustomer(res.customer)
        setInvoiceCreditStatus(res.currentInvoiceCreditStatus)
        setInvoicePaymentStatus(checkInvoicePaid.status)
        setIsInvoicePaid(checkInvoicePaid.isPaid)
        setLoading(false)
      }
    }
    bootstrap()
  }, [invoiceNumber, supplierCompanyId])

  return {
    invoice,
    customer,
    invoiceCreditStatus,
    loading,
    isInvoicePaid,
    invoicePaymentStatus,
  }
}
